import React from "react"
import {BusinessApplication, IndividualApplication, requestDocument} from "../../resources/application"
import {BeneficialOwnerResource} from "../../resources/beneficialOwner"
import {BusinessRequestDocumentModal, IndividualRequestDocumentModal} from "./RequestDocumentModal"

export function OnboardingBusinessRequestDocumentModal({
	close,
	application,
	beneficialOwners,
	onSuccess,
}: {
	application: BusinessApplication
	beneficialOwners?: BeneficialOwnerResource[]
	close: () => void
	onSuccess: () => void
}) {
	return (
		<BusinessRequestDocumentModal
			applicationId={application.id}
			officer={application.attributes.officer}
			officerRelationshipId={application.relationships.officer?.data.id}
			beneficialOwners={beneficialOwners}
			hasOperatingAddress={!!application.attributes.operatingAddress}
			showPersonEntities={!application.attributes.publicTradedCompany}
			requestFn={requestDocument}
			close={close}
			onSuccess={onSuccess}
		/>
	)
}

export function OnboardingIndividualRequestDocumentModal({
	close,
	application,
	onSuccess,
}: {
	application: IndividualApplication
	close: () => void
	onSuccess: () => void
}) {
	return (
		<IndividualRequestDocumentModal
			applicationId={application.id}
			ssn={application.attributes.ssn}
			passport={application.attributes.passport}
			matriculaConsular={application.attributes.matriculaConsular}
			requestFn={requestDocument}
			close={close}
			onSuccess={onSuccess}
		/>
	)
}
